// const frontendCardDescription: string = `I'm an experienced software engineer who constantly seeks out innovative solutions to everyday problems.
//  In my years in this industry, I've honed my analytical thinking and collaboration skills, and I love working with a team. I've also had the 
//  opportunity to serve as the software engineer lead for three projects with First Technology`;

 const frontendCardDescription: string = `Delivering well designed, performant and optimized front end for your project. 
 With the experience in variety of technologies and leading development with team colaboration and agile methodologies. Creating web application at minimized sizes
 and fast performance with automated testing to deliver your best application.`;

const frontendTechnologiesAndTools: string[] = [
  "React",
  "Redux",
  "JavaScript",
  "TypeScript",
  "Less",
  "Sass",
  "Ant Design",
  "Material UI",
  "React testing library",
  "Jest",
  "Cypress",
  "VS Code",
  "Postman",
  "Jira",
  "Google Documents",
]

export { frontendCardDescription, frontendTechnologiesAndTools };
